import { ReactNode } from 'react'

import styles from './yourlibraryheader.css'

type YourLibraryHeaderProps = {
  title: string
  description?: string
  image?: ReactNode
}

const YourLibraryHeader = ({ title, description, image }: YourLibraryHeaderProps): JSX.Element => (
  <div className={styles.wrapper}>
    {image && <div className={styles.image}>{image}</div>}
    <div>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.description}>{description}</p>
    </div>
  </div>
)

export default YourLibraryHeader
